<template>
  <div>
    <b-card no-body class="mb-2">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-1 variant="outline-primary">
          Кибермедицинская Скрининговая Диагностика
        </b-button>
      </b-card-header>
      <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text class="alert alert-warning">
            Научно-практическая дисциплина, построенная на базовых принципах физиологии кровообращения,
            изучающая физико-математические проблемы реагирования биологической системы на стресс как на
            травматическое повреждение, и реализующая полученные знания в кибернетических моделях в
            соответствии с положениями теории управления.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
    <template v-if="selectedItem.id">
      <NewDiagnostics @showAll="showAll" v-bind:authorizationToken="authorizationToken"
                      v-bind:item="selectedItem"/>
    </template>
    <template v-else>
      <NewClient @create="createNewClient"/>
      <b-table v-if="items.length > 0" striped small outlined responsive stacked="sm"
               primary-key="id"
               :items="items"
               :fields="fields">
        <template v-slot:cell(show_details)="row">
          <b-button size="sm" variant="danger" class="mx-1" @click="newDiagnostics(row.item)">
            Диагностика
          </b-button>
        </template>
      </b-table>
      <div v-else-if="isBusy" class="text-center text-danger my-2">
        <b-spinner class="align-middle"></b-spinner>
      </div>
    </template>
  </div>
</template>

<script>
import NewClient from './NewClient.vue';
import NewDiagnostics from './NewDiagnostics.vue';
import axios from 'axios';

export default {
  props: {
    authorizationToken: {
      type: String,
      default: '',
    },
    clientLogin: {
      type: String,
      default: '',
    }
  },
  components: {
    NewClient,
    NewDiagnostics
  },
  created: function () {
    axios.defaults.baseURL = 'https://l01s75qla5.execute-api.us-east-1.amazonaws.com/prod';
    axios.defaults.headers.common['Authorization'] = this.authorizationToken;
    this.doClient('');
  },
  data() {
    return {
      isBusy: true,
      fields: [{
        key: 'clientName',
        label: 'Имя',
        class: 'text-left'
      }, {
        key: 'show_details',
        label: 'Действие',
        class: 'text-right'
      }],
      items: [],
      selectedItem: {
        id: this.clientLogin
      }
    }
  },
  methods: {
    doClient(c) {
      this.isBusy = true;
      let vm = this;
      axios.post('/action', {
        clientName: c
      }).then(function (response) {
        vm.isBusy = false;
        vm.items.splice(0);
        response.data.forEach(function (item) {
          vm.items.push({
            site: 'www.cyberhealth.ru',
            id: item.clientLogin,
            clientName: item.clientName,
            _showDetails: false,
          });
        });
      }).catch(function () {
        //  ignore
      });
    },
    createNewClient(c) {
      if (c) {
        this.doClient(c);
      }
    },
    newDiagnostics(item) {
      this.selectedItem = item;
    },
    showAll() {
      this.selectedItem = {};
    }
  }
}
</script>

<style>
table.b-table[aria-busy='true'] {
  opacity: 0.6;
}
</style>